var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4226 2.57728C37.8592 6.01366 37.859 11.6369 34.4228 15.0734L27.0713 22.425C22.7334 26.7628 15.359 25.49 12.9967 20.08C15.5902 17.8259 16.8547 18.555 19.3257 19.6003C20.7803 20.2154 22.4866 19.8861 23.6674 18.7051L30.8488 11.524C32.4018 9.97079 32.402 7.42927 30.8488 5.87607C29.2959 4.32322 26.753 4.32437 25.2012 5.87607L20.0502 11.0272C18.346 10.2079 16.4284 9.96508 14.5976 10.2995C14.974 9.66146 15.4297 9.07367 15.9538 8.55012L21.9266 2.57735C25.3631 -0.85896 30.9862 -0.859249 34.4226 2.57728ZM2.57728 34.4226L2.57735 34.4227C6.01387 37.8591 11.6369 37.8591 15.0733 34.4227L21.2652 28.2308C21.8081 27.6885 22.2776 27.0773 22.6617 26.4128C20.6472 26.9152 18.4874 26.703 16.5963 25.7765L11.5238 30.8489C9.97215 32.4005 7.42941 32.402 5.87635 30.8489C4.32322 29.2958 4.32315 26.7544 5.87635 25.2014L13.0577 18.0199C14.5293 16.5483 17.4661 16.1096 19.6857 18.1419C21.8341 17.9155 22.6685 17.5051 24.003 16.2273C21.1559 11.2066 14.0588 10.4451 9.92879 14.5751L2.57728 21.9267C-0.859094 25.3631 -0.859094 30.9862 2.57728 34.4226Z",
    fill: "#805AED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.2960a89167bcc2cc7c163f1951c451f2.svg";
export { ForwardRef as ReactComponent };